import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/Landing';
import Start from '@/components/Start';
import Questions from '@/components/Questions';
import Thanks from '@/components/Thanks';

Vue.use(Router);

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
    },

    {
      path: '/start',
      name: 'Start',
      component: Start,
    },

    {
      path: '/questions',
      name: 'Questions',
      component: Questions,
      //props: (route) => ({ n: Number(route.params.n) }),
    },

    {
      path: '/thanks',
      name: 'Thanks',
      component: Thanks,
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js